var KEYCODES = {
  ALT: 18,
  BACKSPACE: 8,
  DELETE: 46,
  DOWN_ARROW: 40,
  ESC: 27,
  ENTER: 13,
  LEFT_ARROW: 37,
  RIGHT_ARROW: 39,
  SHIFT: 16,
  SPACEBAR: 32,
  TAB: 9,
  UP_ARROW: 38
};
export default KEYCODES;